import { render, staticRenderFns } from "./veStuMoralResourceAdmin.vue?vue&type=template&id=76fc3640&scoped=true"
import script from "./veStuMoralResourceAdmin.vue?vue&type=script&lang=js"
export * from "./veStuMoralResourceAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc3640",
  null
  
)

export default component.exports